module.exports = __webpack_public_path__ + "static/stat-screen-4c35dc265fba95670950d9604abe55c4.png";